import type { Models, SkyOS } from '@smartlinkdev/types';

export type AnimateConfig = SkyOS.Maps.Animation.AnimateConfig;

export interface BrowserSettings {
  disableClickRouting: boolean;
  disableYouAreHere: boolean;
  directionalYouAreHere: boolean;
  snapToLine: boolean;
  deviceRouting: boolean;
  disableInitialFlyin: boolean;
  isMobile: boolean;
}

export interface MapServiceConstructorConfig {
  browserSettings: BrowserSettings;
  containerId: string;
  debug: boolean;
  settings: SkyOS.MapSettings;
  startingZoom?: number;
  GeoTimeoutDuration?: number;
  clickTesting?: boolean;
}

export interface LngLat {
  lng: number;
  lat: number;
}

export interface LocationClick {
  location: Models.Location;
  latLng: LngLat;
}

export interface PaddingOptions {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

export enum MapEvents {
  JS_READY = 'jsReady',
  READY = 'ready',
  LOCATION_CLICK = 'locationClick',
  FLOOR_CHANGE = 'floorchange',
  ERROR = 'error',
}

export interface APIExport {
  amenities: Models.Amenity[];
  events: Models.Event[];
  locations: Models.Location[];
  venue: Models.Venue[];
  floors: Models.Floor[];
  floor_transitions: Models.FloorTransition[];
  map_backgrounds: Models.MapBackground[];
  lighting: Models.Light[];
  map_suites: Models.MapSuite[];
  venue_languages?: Models.Language[];
}

export interface EnhancedExport extends APIExport {
  amenityCategories: Models.Category[];
  locationCategories: Models.Location[];
}

export interface AmenityTypeListing {
  id: number;
  name: string;
  icon: string;
  count: number;
}

export interface AnyToAnyConfig {
  startIdString: string;
  endIdString: string
  handicapMode: boolean
  paddingRight?: number | undefined;
}
